import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type {
	DefaultArea,
	TaskListArea,
	TaskListAreasData,
	TaskListAreasSummary,
} from "../models/TaskListArea";

/** The areas at or below an asset, the summary of its task list, and the default areas. */
export const getTaskListAreas = async (
	assetId: number | null,
	signal?: AbortSignal,
): Promise<TaskListAreasData> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "AssetId", value: assetId }];

	const resp = await apiService.callV2(
		"[MMS].[GetTaskListAreas]",
		parameters,
		signal,
	);

	if (!resp.ok) {
		throw new Error(resp.message);
	}

	return {
		areas: get(resp, "data.tables[0].rows", []) as TaskListArea[],
		summary: get(
			resp,
			"data.tables[1].rows[0]",
			null,
		) as TaskListAreasSummary | null,
		defaultAreas: get(resp, "data.tables[2].rows", []) as DefaultArea[],
	};
};

export const setTaskListArea = async (
	assetId: number,
	isTaskListRoot: boolean,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "AssetId", value: assetId },
		{ name: "IsTaskListRoot", value: isTaskListRoot },
	];

	return await apiService.callV2("[MMS].[SetTaskListArea]", parameters);
};
